
import { call, put, take, takeEvery } from 'redux-saga/effects'
import URI from 'urijs';

import getPromiseCallback from '../utils/getPromiseCallback';

import { createActionTypes } from './common';

export const CREATE_ACCOUNT_ACTION_TYPE = createActionTypes('auth/CREATE_ACCOUNT');
export const CREATE_ACCOUNT_2_ACTION_TYPE = 'auth/CREATE_ACCOUNT_2';
export const LOGIN_ACTION_TYPE = createActionTypes('auth/LOGIN');
export const LOGOUT_ACTION_TYPE = createActionTypes('auth/LOGOUT');

const LOCAL_STORAGE_KEY_TOKEN = 'auth_token';

export function getActions(dispatch) {
    return {
        createAccount: (username, password, fullName, email) => dispatch({
            type: CREATE_ACCOUNT_2_ACTION_TYPE, username, password, fullName, email
        }),
        login: (username, password) => dispatch({
            type: LOGIN_ACTION_TYPE.DEFAULT, username, password
        }),
        logout: (token) => dispatch({
            type: LOGOUT_ACTION_TYPE.DEFAULT, token
        })
    };
}

function* getToken() {
    let token = (window && window.location) ? getTokenWindowLocation() : null;
    if (!token) {
        token = yield call([localStorage, 'getItem'], LOCAL_STORAGE_KEY_TOKEN);
        if (token) {
            console.log('Token from localStorage:', token);
        }
    }
    return token;
}

function getTokenWindowLocation() {
    let uri = new URI(window.location.href);
    let token = uri.search(true).token;
    if (token) {
        console.log('Token from URL:', token);
        uri.removeSearch('token');
        window.history.pushState('', '', uri.toString());
    }
    return token;
}

function createAccount(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'auth',
            name: 'createAccount',
            body: {
                user: {
                    username: action.username,
                    password: action.password,
                    full_name: action.fullName,
                    email: action.email
                }
            },
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function login(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'auth',
            name: 'login',
            body: {
                user: {
                    username: action.username,
                    password: action.password
                }
            },
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function logout(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'auth',
            name: 'logout',
            token: action.token,
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function verify(serverApi, token) {
    return new Promise((resolve, reject) => {
        serverApi.callGet({
            module: 'auth',
            name: 'verify',
            token: token,
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

export function* authFlow(options) {
    if (options && (options.anonymous === true)) {
        console.log('anonymous, auth flow is disabled');
        return;
    }
    let token = yield call(getToken);
    while (true) {
        try {
            let authData = null;
            if (token) {
                yield put({type: LOGIN_ACTION_TYPE.DEFAULT});
                authData = yield call(verify, options.serverApi, token);
            } else {
                const loginAction = yield take(LOGIN_ACTION_TYPE.DEFAULT)
                authData = yield call(login, options.serverApi, loginAction);
            }
            yield call([localStorage, 'setItem'], LOCAL_STORAGE_KEY_TOKEN, authData.user.token);
            yield put({type: LOGIN_ACTION_TYPE.SUCCESS, data: authData});

            const logoutAction = yield take(LOGOUT_ACTION_TYPE.DEFAULT)
            try {
                const data = yield call(logout, options.serverApi, logoutAction);
                yield call([localStorage, 'removeItem'], LOCAL_STORAGE_KEY_TOKEN);
                yield put({type: LOGOUT_ACTION_TYPE.SUCCESS, data: data});

                let afterLogoutUrl = logoutAction.logoutUrl || options.afterLogoutUrl;
                if (options && options.history && afterLogoutUrl) {
                    if (afterLogoutUrl.indexOf('#') !== -1) {
                        yield call([window.location, 'assign'], afterLogoutUrl);
                    } else {
                        yield call(options.history.push, afterLogoutUrl);
                    }
                }
            } catch (error) {
                yield put({type: LOGOUT_ACTION_TYPE.FAILED, error});
            }

        } catch (error) {
            yield put({type: LOGIN_ACTION_TYPE.FAILED, error});
        }

        token = null;
    }
}

function* workCreateAccount(options, action) {
    try {
        yield put({type: CREATE_ACCOUNT_ACTION_TYPE.DEFAULT});
        const authData = yield call(createAccount, options.serverApi, action);
        if (authData && authData.user) {
            yield put({type: LOGIN_ACTION_TYPE.DEFAULT, username: action.username, password: action.password});
        }
    } catch (error) {
        console.log(error);
        yield put({type: CREATE_ACCOUNT_ACTION_TYPE.FAILED, error});
    }
}

export function* watchCreateAccount(options) {
    yield takeEvery(CREATE_ACCOUNT_2_ACTION_TYPE, workCreateAccount, options);
}

